import { Settings } from './Settings';
//import { Math } from './Math'
import {
    VerifyNumericLimit_Btw_MinMax,
    VerifyNumericLimit_ByLimit,
    RoundValueASTM,
    RoundValueASTM_ValAsStr,
    Approximates,
    RemoveScientificNotation,
    GetDecimalsFromString,
    VpsCommodity,
    VpsGravityType,
    VpsTemperatureUnit,
    VpsQuantityUnit
} from './FuelMath';
export class CetaneService {
    static response = {

        CIITextBox: ""
    };
    static CalculateCetane(config) {
        ;
        let Density = config.gravity?parseFloat(config.gravity):0;
        let Temperature1 = config.Temperature1?parseFloat(config.Temperature1):0;
        let Temperature2 = config.Temperature2?parseFloat(config.Temperature2):0;
        let Temperature3 = config.Temperature3?parseFloat(config.Temperature3):0;
        let GravityType = config.GravityType;

        let DN = (parseFloat(Density) / 1000) - 0.85;
        let B =  Math.pow(Math.exp(1),(-3.5 * DN))-1
        let T10 = parseFloat(Temperature1) - 215.0;
        let T50 = parseFloat(Temperature2) - 260.0;
        let T90 = parseFloat(Temperature3) - 310.0;
        let pow1 = Math.pow(T10,2);
        let pow2 = Math.pow(T90,2);
        let pow3 = Math.pow(B,2);

        let T50s= parseFloat(Temperature2);
        let logT50 = Math.log10(T50s);
        let powlogT50 = Math.pow(logT50, 2);
        let powT50 = Math.pow(T50s, 2);

        if(config.calcmethod==="ISO 4264"){
         let CCI = (45.2 + (0.0892 * T10) + ((0.131 + (0.901 * B)) * T50) + 
				 ((0.0523 - (0.42 * B)) * T90) + (0.00049 * ((pow1) - (pow2))) + 
				 (107.0 * B) + ((60.0 * (pow3)))).toFixed(1);
        return CCI
        } else if(config.calcmethod==="ASTM D976"){
           
            if (GravityType === VpsGravityType.Density) {
                let D = (parseFloat(Density) / 1000);
                let powD = Math.pow(D, 2);
                let CCI = (454.74 - (1641.416 * D) + (774.74 * (powD)) -
                    (0.554 * T50s) + (97.803 * (powlogT50))).toFixed(1);
                return CCI
            } else if (GravityType === VpsGravityType.API) {
                let A = parseFloat( Density);
                let powA = Math.pow(A, 2);
                let CCI = (-420.34 + (0.016 * (powA)) + (0.192 * A * logT50) +
                    (65.01 * (powlogT50)) - (0.0001809 * (powT50))).toFixed(1);
                return CCI
            }
        }
    }
}